import type { PulseEvent, PulseEventName } from '../pulseSchema';
import { registerPulseGa4MirrorHook } from '../pulseTracker';
import { pulseEnvelopeToGa4Params } from './ga4Envelope';
import { isGa4Enabled, trackGa4Event } from './ga4Tracker';

/** Internal Pulse events — not mirrored to GA4 reporting. */
export const GA4_EXCLUDED_EVENT_NAMES = new Set<PulseEventName>([
  'consent',
  'context',
  'session_stats',
]);

export const shouldMirrorPulseEventToGa4 = (event: PulseEvent): boolean => {
  if (!isGa4Enabled()) return false;
  return !GA4_EXCLUDED_EVENT_NAMES.has(event.event_name as PulseEventName);
};

/** Mirror a Pulse envelope to GA4 when the event is sent to Pulse (independent of Pulse response). */
export const mirrorPulseEventToGa4 = (envelope: PulseEvent): void => {
  if (!shouldMirrorPulseEventToGa4(envelope)) return;

  const params = pulseEnvelopeToGa4Params(envelope);
  trackGa4Event(envelope.event_name, params as Record<string, unknown>);
};

/** Wire GA4 mirroring alongside Pulse sends. */
export const registerGa4PulseMirror = (): (() => void) => {
  if (!isGa4Enabled()) {
    return () => {};
  }

  registerPulseGa4MirrorHook(mirrorPulseEventToGa4);
  return () => registerPulseGa4MirrorHook(null);
};
